import { OptionDto } from "@/dtos"; 
import { TripPatternPlottedOrientation } from "@/helpers/types";


const statusDispatch = [
    { value: TripPatternPlottedOrientation.OUTBOUND, label: 'VIAJE DE IDA' },
    { value: TripPatternPlottedOrientation.INBOUND, label: 'VIAJE DE VUELTA' },
    { value: TripPatternPlottedOrientation.CIRCULAR, label: 'VIAJE CIRCULAR' }
] as OptionDto[];

 

export const getStatusDispatch = (value: number): OptionDto => {
    return statusDispatch.find((x) => x.value == value) ?? statusDispatch[0];
}

